export default __webpack_public_path__ + "static/media/coins.848d0af7.jpg";